import React from 'react';

type PaymentsEnv = {
  isTokenValid: boolean;
  reservationId?: string;
  insuranceSetupId?: string | null;
  isCheckoutReservation?: boolean;
  isBookingPaymentsActive?: boolean;
  isMobileSheetMenuAvailable?: boolean;
};

const PaymentsEnvContext = React.createContext<PaymentsEnv>({isTokenValid: false});

function usePaymentsEnv() {
  return React.useContext(PaymentsEnvContext);
}

export {PaymentsEnvContext, usePaymentsEnv};
export type {PaymentsEnv};
